"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.priceDropRestrictedStates = exports.noSelectedSuggestion = exports.SearchType = exports.SearchBarEvents = exports.GET_SUGGESTIONS_V3 = void 0;
exports.GET_SUGGESTIONS_V3 = '/merch/search/api/v3/suggest';
var SearchBarEvents;
(function (SearchBarEvents) {
    SearchBarEvents["ClearedText"] = "Search Bar Cleared Text";
    SearchBarEvents["Focused"] = "Search Bar Focused";
    SearchBarEvents["GoClicked"] = "Go Clicked";
    SearchBarEvents["NoResults"] = "No Results";
    SearchBarEvents["PressedEnter"] = "Pressed Enter";
    SearchBarEvents["RemovedRecentSearch"] = "Removed Recent Search";
    SearchBarEvents["SuggestionClicked"] = "Suggestion Clicked";
    SearchBarEvents["Viewed"] = "Suggestions Viewed";
})(SearchBarEvents || (exports.SearchBarEvents = SearchBarEvents = {}));
var SearchType;
(function (SearchType) {
    SearchType["DefaultSuggestion"] = "DefaultSuggestion";
    SearchType["SavedSearch"] = "SavedSearch";
    SearchType["RecentSearch"] = "RecentSearch";
    SearchType["TextSearch"] = "TextSearch";
})(SearchType || (exports.SearchType = SearchType = {}));
exports.noSelectedSuggestion = {
    href: '/cars',
    text: ''
};
exports.priceDropRestrictedStates = [
    'AR',
    'CA',
    'CT',
    'IL',
    'LA',
    'OR',
    'TX',
    'UT'
];
//# sourceMappingURL=constants.js.map